// w9.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W9 = () => {
  return <WW config={pageConfigs.w9} />;
};

export default W9;
